exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-overlay[data-v-0b234672]{position:fixed;top:0;left:0;width:100%;height:100%;background:hsla(0,0%,100%,.8);display:flex;align-items:center;justify-content:center;z-index:1050}", ""]);

// exports
